import auth from '../../../api/auth'


export default {

  Now_yyyy_MM_dd() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  Date_yyyy_MM_dd(val) {
    let today = new Date(val);
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  http_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/Coper/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        
      }
    })
  },

  api_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),

      }
    })
  },

  api_post_FileDownload(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
      },responseType: "arraybuffer"
    })
  },

  CreateDownloadLink(response,fileName){
    console.log(response);
    let contentType = response.headers.get("Content-Type");
 
    
    let blob = new Blob([response.data], {
      type: contentType
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  },

  api_file_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        'Content-Type': 'multipart/form-data'

      }
    })
  },


  api_file_post2(owner, url, files, prm) {

    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      formData.append('files[' + i + ']', file);
    }

    if (prm==undefined){
      prm={}
    }

    formData.append('jsondata',JSON.stringify(prm))

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, formData, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        'Content-Type': 'multipart/form-data'

      }
    })
  },


   responseToStatus(response) {
    let status = this.NewSatatus();
    if (response.status === 0) {
      status.text = this.$t('The-web-service-is-out-of-service-Please-try-again-later.');
      status.show = true;
      status.loading = false;
    } else {
      status.text = response.statusText
      if((response.body != null) && (response.body.ExceptionMessage != null))
      {
        status.text = response.body.ExceptionMessage;
      }
      status.show = true;
      status.loading = false;
      //let enc = new TextDecoder("utf-8");
      //console.log(enc.decode(response.body));
    }
    return status
  },


  NewSatatus() {
    return {
      show: false,
      text: "",
      loading: false,
    }
  }





}